import { useEffect } from "react";
import { useThreeDotsPartClaimContext } from "./context";
import { ThreeDotsPartSearchClaimComponentsKeys } from ".";

interface IOptionEmptySearchClaimProps {
	option: ThreeDotsPartSearchClaimComponentsKeys;
}
function OptionEmptySearchClaim({ option }: IOptionEmptySearchClaimProps) {
	const { hideOption } = useThreeDotsPartClaimContext();

	useEffect(() => {
		hideOption(option);

		return () => {
			hideOption(option);
		};
	}, []);
	return <></>;
}

export default OptionEmptySearchClaim;
